let CPF: any = require('cpf_cnpj/lib/cpf');

export default (ngModule: ng.IModule) => {

  ngModule
    .directive('cpf', function cpf() {
      return {
        restrict: 'A',
        require: 'ngModel',
        link: link
      };

      function link(scope, elem, attrs, ctrl) {
        scope.$watch(attrs.ngModel, function (newVal) {
          ctrl.$setValidity('cpf', !newVal || CPF.isValid(newVal));
        });
      }
    });
};



/** WEBPACK FOOTER **
 ** ../~/tslint-loader!./common/decorators/cpf.directive.ts
 **/